module.exports = __webpack_public_path__ + "img/Chef_GabyRuiz.57a92e2c.jpeg";